import { SortableContext, verticalListSortingStrategy, horizontalListSortingStrategy, rectSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import style from "./style.module.css";

const PictureBox = ({ thumbnails, setThumbnails, setImages }) => {

  const handleRemoveImage = (id) => {
    setThumbnails((prevState) => prevState.filter((obj) => obj.id !== id));
    setImages((prevState) => prevState.filter((obj) => obj.id !== id));
  };

  const Picture = ({ id, fileURL }) => {

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const dndStyle = {
      transition,
      transform: CSS.Transform.toString(transform),
    };

    return (
      <div
        ref={setNodeRef}
        style={dndStyle}
        {...attributes}
        {...listeners}
        className={style.imgBox}
      >
        <img className={style.img} src={fileURL} alt={`Thumbnail`} loading="lazy"/>
        <button
          className={style.removeImgBtn}
          onPointerDown={event => {
            event.stopPropagation();
            handleRemoveImage(id);
          }}
        >x</button>
      </div>
    );
  };

  return (
    <div className={style.imgList}>
      <SortableContext items={thumbnails} strategy={rectSortingStrategy}>
        {thumbnails && thumbnails.map(thumbnail => (
          <Picture id={thumbnail.id} fileURL={thumbnail.fileURL} key={thumbnail.id}/>
        ))}
      </SortableContext>
    </div>
  );
};

export default PictureBox;